<template>
  <div>
    <div v-if="question !== null" class="hpanel">
      <div class="panel-heading">
        <span class="label label-info ">{{status}}</span>
        <template v-if="workflowId === 3"> The Tech offer</template>
        <template v-else> The Question</template>
        <div class="pull-right text-right">
          <div class="btn-group">
            <template v-if="question.status_id < 3 || $auth.check('super_admin') ">

              <router-link v-if="!$user.isBasic()" class="btn btn-xs btn-info" :to="{name: 'QuestionEdit', params: toQuestionParams}"><i class="fas fa-pencil-alt"></i> Edit</router-link>
              <button v-else class="btn btn-xs btn-info" @click="$refs.limitPlan.show('editQuestion')"><i class="fa fa-lock"></i> Edit</button>
            </template>
            <router-link class="btn btn-xs btn-info" :to="{name: 'QuestionReview', params: {project_id: projectId, question_id: questionId}}"><i class="fa fa-eye"></i> Preview</router-link>
          </div>
        </div>

      </div>
      <div class="panel-body" style="">
        <div v-if="large !== true" >
          <div class="row">

            <div :class="question.picture ? 'col-xs-6' : 'col-xs-12'">
              <h4 style="color: black;" v-if="question.title">{{question.title}}</h4>
              <div class="text-muted font-bold m-b-xs">overview :</div>
              <p>
                <template v-if="question.company_profile">{{question.company_profile}}</template>
                <template v-if="question.objective">{{question.objective}}</template>
              </p>
            </div>
            <div class="col-xs-6 text-center" v-if="question.picture">
              <img :src="api_url + question.picture" style="max-height: 150px;max-width: 100%"/>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <p v-if="question.issue">{{question.issue}}</p>
              <p v-if="question.restraint">{{question.restraint}}</p>
              <p v-if="question.expert_interest">{{question.expert_interest}}</p>
            </div>
          </div>

        </div>
        <div v-else>
          <question-resume-large :question="question"/>
        </div>
      </div>
    </div>
    <div v-else-if="workflowId === 3" class="hpanel">
      <div class="panel-heading">
        <span class="label label-info">Empty</span>
        The Tech offer
      </div>
      <div class="panel-body " style="background-color: transparent;height: 150px;">
        <div class="row" style="height: 100%">
          <div class="text-center m-b-md" style="">
            <p>
              <label>Empty Tech offer</label>
            </p>

            <router-link v-if="!$user.isBasic()" :to="{ name: 'QuestionEdit', params: toQuestionParams}" class="btn btn-info"> Create Tech offer</router-link>
            <button v-else class="btn btn-info" @click="$refs.limitPlan.show('createQuestion')"><i class="fa fa-lock"></i> Create Tech offer</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="hpanel">
      <div class="panel-heading">
        <span class="label label-info">Empty</span>
        The Question
      </div>
      <div class="panel-body " style="background-color: transparent;height: 150px;">
        <div class="row" style="height: 100%">
          <div class="text-center m-b-md" style="">
            <p>
              <label>Empty question</label>

            </p>
            <router-link v-if="!$user.isBasic()" :to="{ name: 'QuestionEdit', params: toQuestionParams}" class="btn btn-info"> Create question</router-link>
            <button v-else class="btn btn-info" @click="$refs.limitPlan.show('createQuestion')"><i class="fa fa-lock"></i> Create question</button>
          </div>
        </div>
      </div>
    </div>
    <limit-plan ref="limitPlan"></limit-plan>

  </div>

</template>

<script>
import QuestionResumeLarge from './resume/QuestionResumeLarge'
import LimitPlan from '../../components/LimitPlan'

export default {
  components: {QuestionResumeLarge, LimitPlan},
  name: 'QuestionResume',
  props: ['questionId', 'projectId', 'workflowId', 'large'],
  data () {
    return {
      question: null,
      toQuestionParams: null,
      api_url: process.env.API_URL
    }
  },
  watch: {
    questionId: function (val) {
      if (val !== null) {
        this.getResources()
      }
    }
  },
  computed: {
    status: function () {
      let status

      switch (this.question.status.id) {
        case 1:
          status = 'Draft'
          break
        case 2:
          status = 'Submitted'
          break
        case 3:
          status = 'Reviewed'
          break
        case 4:
          status = 'Published'
          break
        case 5:
          status = 'Closed'
          break
      }
      return status
    }
  },
  methods: {
    getResources: function () {
      if (this.questionId !== null) {
        this.axios.get('/question/' + this.questionId)
          .then((response) => {
            this.question = response.data
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            }
            if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            }
          })
      }
    }
  },
  beforeMount () {
    if (this.questionId !== null) {
      this.toQuestionParams = {
        project_id: this.projectId,
        question_id: this.questionId
      }
      this.getResources()
    } else {
      this.toQuestionParams = {
        project_id: this.projectId
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/QuestionResume.vue